import { render, staticRenderFns } from "./ScreenCard.vue?vue&type=template&id=be3af3f0&scoped=true"
import script from "./ScreenCard.vue?vue&type=script&lang=js"
export * from "./ScreenCard.vue?vue&type=script&lang=js"
import style0 from "./ScreenCard.vue?vue&type=style&index=0&id=be3af3f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3af3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be3af3f0')) {
      api.createRecord('be3af3f0', component.options)
    } else {
      api.reload('be3af3f0', component.options)
    }
    module.hot.accept("./ScreenCard.vue?vue&type=template&id=be3af3f0&scoped=true", function () {
      api.rerender('be3af3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/screens/ScreenCard.vue"
export default component.exports